import { useCallback, useEffect } from 'react';

import { useHomeGamesWidget } from '@swf/poker';

const usePollClubInfo = () => {
  const { widgetDispatch } = useHomeGamesWidget();

  const fetchData = useCallback(() => {
    widgetDispatch.fetchLobbyData({ polling: true });
  }, [widgetDispatch]);

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;

    interval = setInterval(
      fetchData,
      60 * 1000 // every minute
    );

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [fetchData]);
};

export default usePollClubInfo;
